import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import Vform17MultiOptions from './Vform17MultiOptions.vue' 

declareVconsoleComponent('vform17MultiOptions', Vform17MultiOptions, 'vform17_multi_options:component')